"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotifications = void 0;

var _locales = require("../locales");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @desc
 * Returns notifications matched the given namespace.
 *
 * @public
 * @function
 *
 * @param notifications - The notification object from the state.
 * id - Unique identifier for notification
   time - Time of the notification
   severity - Severity [ERROR, WARNING, INFO]
   title - Notification title
   titleParams - Parameters to the notification title, when it is a formatMessage object and needs static params
   message - Notification message
   messageParams - Parameters to the notification message, when it is a formatMessage object and needs static params
   notificationParams: { closeButton } - Additional parameters to be passed down to notifications. closeButton - Boolean which sets if the notification has a close button.
 * @param namespace - Namespace of the notification to by identified by as a param.
 * @param formatMessage - optional param, if provided, the messages are going to be translated here, otherwise they are going to be translated in the notification dropdown component.
 * @returns {Array}
 */
var getNotifications = function getNotifications(notifications, namespace) {
  var formatMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var translatedNotifications = notifications.map(function (notification) {
    if (formatMessage) {
      return _objectSpread(_objectSpread({}, notification), {}, {
        title: (0, _locales.translateMessage)(formatMessage, notification.title, notification.titleParams),
        message: (0, _locales.translateMessage)(formatMessage, notification.message, notification.messageParams)
      });
    }

    return notification;
  });

  if (!namespace) {
    return translatedNotifications;
  } // get notifications by namespace


  return translatedNotifications.filter(function (notification) {
    return notification.namespace === namespace;
  });
};

exports.getNotifications = getNotifications;
//# sourceMappingURL=get-notifications.js.map